import { h } from 'preact';
import { forwardRef } from 'preact/compat';
import { useEffect, useState } from 'preact/hooks';
import SearchIcon from 'utils/icon/icon-search.svg';
import { getCookie, setCookie } from 'utils/helpers';
import { useLocations } from './locations-context';

const PlacesAutocomplete = forwardRef((props, ref) => {
  const {
    userCurrentLocation,
    useMyLocation,
    setUserCurrentLocation,
    setLoadingResults,
    setLocationServicesError,
    setNoResults,
  } = useLocations();
  const [searchQuery, setSearchQuery] = useState('');
  const handleInput = (e) => {
    setSearchQuery(e.target.value);
    setLocationServicesError(null);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      const selected = document.querySelector('.pac-item-selected');
      if (!selected) {
        const suggestion = document.querySelector(
          '.pac-container .pac-item:first-child',
        );
        if (suggestion) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.target.dispatchEvent(
            new KeyboardEvent('keydown', {
              keyCode: 40,
              which: 40,
            }),
          );
          e.target.dispatchEvent(
            new KeyboardEvent('keydown', {
              keyCode: 13,
              which: 13,
            }),
          );
        }
      }
    }
  };
  const handleClear = (e) => {
    e.preventDefault();
    setSearchQuery('');
    setLocationServicesError(null);
    setCookie('store_search', 1, 0);
    if (getCookie('geo_enabled')) {
      useMyLocation();
    } else {
      setUserCurrentLocation(null);
    }
  };

  useEffect(() => {
    const input = document.getElementById('pac-input');
    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ['ca'] },
      fields: ['address_components', 'geometry.location', 'icon', 'name'],
    });
    autocomplete.addListener('place_changed', () => {
      setLocationServicesError(null);
      const placeResult = autocomplete.getPlace();
      if (placeResult.geometry?.location?.lat()) {
        setNoResults(false);
        setLoadingResults(true);
        setSearchQuery(placeResult.name);
        setCookie('store_search', 1, 1);
        setUserCurrentLocation({
          title: placeResult.name,
          lat: placeResult.geometry?.location?.lat(),
          lng: placeResult.geometry?.location?.lng(),
        });
      } else {
        setNoResults(true);
      }
    });
  }, []);

  return (
    <div className="relative mb-16 mt-24">
      <SearchIcon className="w-24 h-auto absolute left-16 top-1/2 -translate-y-1/2" />
      <input
        id="pac-input"
        type="text"
        onKeyDown={handleKeyDown}
        ref={ref}
        placeholder={window.TMW.Strings.search.places}
        className={`lc:rounded-full bg-grey-300 border-none py-12 body-1 
                    placeholder-black pl-48  w-full line-clamp-1 ${
                      searchQuery.length ||
                      (userCurrentLocation &&
                        userCurrentLocation.type !== 'geo')
                        ? 'pr-96 truncate'
                        : 'pr-4'
                    }`}
        value={searchQuery}
        onInput={handleInput}
      />
      {(!!searchQuery.length ||
        (userCurrentLocation && userCurrentLocation.type !== 'geo')) && (
        <button
          type="button"
          onClick={handleClear}
          role="button"
          className="right-16 bottom-14 absolute eyebrow text-subdued !font-semibold"
        >
          {window.TMW.Strings.storeLocator.clear}
        </button>
      )}
    </div>
  );
});

export default PlacesAutocomplete;
